import { useEffect, useState } from "react";

export default function UICheckbox({ label, initialValue = false, disabled, className, handleChange,hasHtmlFor=true,error,errorMsg,wFull, ...rest}) {

  const [visualState, setVisualState] = useState(initialValue)
  function onChange(e) { handleChange(e) }

  useEffect(() => { setVisualState(initialValue); }, [initialValue]);

  return (
    <div className={`relative flex flex-col justify-start items-start gap-1 ${wFull? "w-full":"w-auto"}`}>
          <div className={`flex relative w-full items-start gap-2 ${disabled && "cursor-not-allowed"} ${className}`} >
      <input id={label} disabled={disabled} type="checkbox" onChange={(e) => onChange(e)} value={initialValue}
        className="appearance-none shrink-0 rounded-sm w-[17px] mt-[2px] h-[17px] cursor-pointer focus:ring-0"
        style={visualState ? checkboxStyleChecked : checkboxStyle}
        {...rest}
      />
      <div className={`absolute block w-[7px] h-[12px] rotate-45 border-b-2 border-r-2  pointer-events-none left-[5px] top-[3px] ${initialValue ? 'border-white' : 'border-transparent'}`} />
      <label htmlFor={hasHtmlFor?label:undefined} className={`text-[14px] ${disabled && "cursor-not-allowed text-slate-400"} ${className}`} >
        {label}
      </label>
    </div>
    {error && errorMsg && <span className="text-xs text-red-600">{errorMsg}</span>}
    </div>

  );
}

const checkboxStyle = {
  border: '1px solid #00CE15',
};

const checkboxStyleChecked = {
  border: '1px solid #00CE15',
  backgroundColor: '#00CE15',
};